import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy } from '../../stateless/copy';
import { AnswersImageRadio } from '../../stateless/answers';
import { NextButton } from '../../stateless/buttons';
import HOCNextStepController from '../../hoc/next-step-controller';
import autobind from 'autobind-decorator';
import { activatePopup } from '../../../state/actions/image-zoom-popup';
import { connect } from 'react-redux';

const EnhancedButton = HOCNextStepController(NextButton);

@connect(
	state => ({}),
	dispatch => {
		return ({
			activatePopup: (image) => {
				dispatch(activatePopup(image));
			}
		})
	}
)
export default class Avatar extends Component {

	static PropTypes = {
		user: PropTypes.object,
		players: PropTypes.object,
		window: PropTypes.object,
		nextWindow: PropTypes.func,
		updateAnswer: PropTypes.func,
		currentValue: PropTypes.string,
		countryCode: PropTypes.string
	};

	componentWillReceiveProps (nextProps) {
		if (this.props.currentValue !== nextProps.currentValue) {
			this.calculateResult(nextProps);
		}
	}

	calculateResult (newProps) {
		let newState = {};
		let { currentValue } = newProps;

		if (currentValue === 'male' || currentValue === 'female') {
			newState.avatar = {"gender": currentValue, "options": [currentValue]};
		} else {
			newState.avatar = {"options": [currentValue]};
		}

		this.props.updateSaveState(newState);
	}

	@autobind
	zoomIn (image) {
		this.props.activatePopup(image);
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		return (
			<div>
				<Copy user={this.props.user} window={this.props.window} countryCode={this.props.countryCode} players={this.props.players}>
					{ this.props.window.current.answers &&
						<AnswersImageRadio
							answers={this.props.window.current.answers}
							updateAnswer={this.props.updateAnswer}
							currentValue={this.props.currentValue}
							countryCode={this.props.countryCode}
							zoomIn={this.zoomIn}
						/>
					}
					<EnhancedButton
						{ ...this.props }
						hasAvatar={ true }
					/>
				</Copy>
			</div>
		)
	}
}
